import  {  useState } from "react";

import {  useAppSelector } from '../../redux/store/storehooks';
import Spinner from "../../components/_common/Spinner";
import './style.css'
import  Table, { ColumnsType } from "antd/lib/table";
import './style.css'

const ParsicServiceLog = () => {

    const columns: ColumnsType<any> = [
        {title: 'نام کاپیوتر',dataIndex: 'Str_ComputerName',key: 'Str_ComputerName'},
        {title: 'توضیحات ',dataIndex: 'Str_Description',key: 'Str_Description'},
       
    ];

  const myStore = useAppSelector((state) => state)
  const [isLoading,setIsLoading] = useState(false);

 
  return(
    <div className="tab-content-padding">
     { 
        isLoading === false  && (
        <>
            <div className="inner-tabs_content">               
                <Table  dataSource={myStore.generalInfo.MyParsicServiceLog} columns={columns} 
                />                                   
        </div>
        </> 
        )
    }
    {
      isLoading === true  && (
      <Spinner />
    )
    }
    </div>  
      
    )
}
export default ParsicServiceLog;
